// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"Disclaimer-module--disclaimer--3tnOX","hidden":"Disclaimer-module--hidden--nS2wX"};